<div class="container mt-4">
    <div class="col-md-4 d-flex align-items-center">
        <h4 class="font-weight-bold later-color title">
            {{ 'presentaciones.tituloPresentacion' | translate }}
        </h4>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>

    <div class="card mt-3" style="background-color: #f5f5f5">
        <div class="card-body d-flex justify-content-between">
            <div class="description">
                <p class="card-text" style="color: black">
                    <span style="font-weight: bold">Nombre del producto:</span>
                    {{ currentProduct.nombreComercial }}
                    <br />
                    <span style="font-weight: bold">
                        Casa productora / Planta productora:
                    </span>
                    {{ currentProduct.casaProductora }}
                    <br />
                    <span style="font-weight: bold">
                        {{ 'presentaciones.numeroIca' | translate }}
                    </span>
                    {{ currentProduct.numeroRegistroIca }}
                </p>
            </div>
            <div class="action col-md-7 text-end">
                <a
                    *ngIf="tipoProductoID != 4"
                    class="btn btn-success text-white"
                    style="border-radius: 20px"
                    (click)="addPresentation()">
                    <i class="fas"></i>
                    Agregar presentación
                </a>
            </div>
        </div>
    </div>

    <div class="float-start mb-3">
        <input
            type="text"
            class="form-control"
            id="busquedaPre"
            placeholder="Buscar"
            [(ngModel)]="busquedaPre" />
        <span class="bi bi-search text-muted"></span>
    </div>

    <table class="table">
        <thead>
            <tr>
                <th>Empaque</th>
                <th>Cantidad</th>
                <th>Unidad de Medida</th>
                <th>Estado</th>
                <th>Opciones</th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="
                    let presentacion of presentaciones | filterPre: busquedaPre
                ">
                <td>{{ presentacion.empaqueUnidadMedida.empaque.nombre }}</td>
                <td>{{ presentacion.cantidad }}</td>
                <td>
                    {{ presentacion.empaqueUnidadMedida.unidadMedida.nombre }}
                </td>
                <td>
                    <div class="d-flex align-items-center">
                        <p
                            [ngClass]="
                                presentacion.estado == true
                                    ? 'productquery_active'
                                    : 'productquery_inactive'
                            ">
                            {{
                                presentacion.estado == true
                                    ? 'Activo'
                                    : 'Inactivo'
                            }}
                        </p>
                    </div>
                </td>
                <td>
                    <button
                        class="btn btn-sm text-white"
                        [ngClass]="{
                            'btn-success': presentacion.estado == false,
                            'btn-warning': presentacion.estado == true,
                        }"
                        (click)="activarPresentacion(presentacion)">
                        {{
                            presentacion.estado == true
                                ? 'Inactivar'
                                : 'Activar'
                        }}
                    </button>
                    <span class="mx-2"></span>
                    <button
                        *ngIf="tipoProductoID != 4"
                        class="btn btn-primary btn-sm productquery_color"
                        (click)="editarPresentacion(presentacion)">
                        Editar
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
